import React from 'react';
import { Spin, Icon } from 'antd';

import style from './Loader.module.scss';


const icon = <Icon type="loading" style={{ fontSize: 24 }} spin />;

export const Loader = () => <div className={ style.wrapper }><Spin indicator={ icon } /></div>;
